import { Statuses } from "./constant";
// import CircleIcon from '@mui/icons-material/Circle';
import { useNavigate, generatePath, useParams } from "react-router-dom";
function StatusPill(props) {
  const { status, row } = props;
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const handleClick = () => {
    if(row){
      navigate(
      generatePath("/client/:clientNameParam/property-form", {
        clientNameParam,
      }),
      {
        state: {
          propertyName: row?.propertyName === undefined ? row?.siteName : row?.propertyName,
          status: status,
          tab: status === Statuses.COMPLETED ? "Completed" : "Active",
        },
      },
    );
    }
    
  };
  const getChipStyle = (status) => {
    switch (status) {
      case Statuses.INPROGRESS:
        return {
          backgroundColor: "#4A55651A",
          color: "#4A5565",
          border: "0.67px solid #4A556533",
        };

      case Statuses.SCHEDULED:
        return {
          backgroundColor: "#222B591A",
          color: "#222B59",
          border: "0.67px solid #222B5933",
        };
      // blue
      case Statuses.COMPLETED:
        return {
          backgroundColor: "#275C011A",
          color: "#275C01",
          border: "0.67px solid #275C0133",
        };
      case Statuses.SUBMITTEDFORAPPROVAL:
        return {
          backgroundColor: "#FF8D281A",
          color: "#FF8D28",
          border: "0.67px solid #FF8D2833",
        };
      case Statuses.REJECTED:
        return {
          backgroundColor: "#E520201A",
          color: "#E52020",
          border: "0.67px solid #E5202033",
        };
      case Statuses.NEW:
        return {
          backgroundColor: "#007BB51A",
          color: "#007BB5",
          border: "0.67px solid #007BB533",
        };
      case Statuses.PENDINGINSPECTORAPPROVAL:
        return {
          backgroundColor: "#A2845E1A",
          color: "#A2845E",
          border: "0.67px solid #A2845E33",
        };

      case Statuses.PENDING:
        return {
          backgroundColor: "#A2845E1A",
          color: "#A2845E",
          border: "0.67px solid #A2845E33",
        };

      case Statuses.HIGH:
        return {
          backgroundColor: "#D35400",
          color: "#FFFFFF",
          border: "0.67px solid #222B5933",

          width: "115px", // adjust if text changes
          height: "32px",
        };
      case Statuses.URGENT:
        return {
          backgroundColor: "#A52A2A",
          color: "#FFFFFF",
          border: "0.67px solid #222B5933",

          width: "115px", // adjust if text changes
          height: "32px",
        };
      case Statuses.OVERDUE:
        return {
          backgroundColor: "#E52020",
          color: "#FFFFFF",
          border: "0.67px solid #E5202033",
        };
      case Statuses.CRITICAL:
        return {
          backgroundColor: "#A52A2A",
          color: "#FFFFFF",
          border: "0.67px solid #222B5933",

          width: "115px", // adjust if text changes
          height: "32px",
        };
      case Statuses.MEDIUM:
        return {
          backgroundColor: "#F1C40F",
          color: "#212121",
          border: "1px solid #222B5933",

          width: "115px", // adjust if text changes
          height: "32px",
        };
      case Statuses.LOW:
        return {
          backgroundColor: "#3BB273",
          color: "#212121",
          border: "1px solid #222B5933",

          width: "115px", // adjust if text changes
          height: "32px",
        };
      case Statuses.BOOKINGCONFIRM:
        return {
          backgroundColor: "#275C011A",
          color: "#275C01",
          border: "0.67px solid #275C0133",
          width: "120px", // adjust if text changes
          height: "35px",
        };
      default:
        return {
          // backgroundColor: "#c3cac7ff",
          color: "#6a6363",
          border: "1px solid #222B5933",
        };
    }
  };
  //   return <Chip label={status} sx={getChipStyle(status)} />
  return (
    // <span className="status-pill" style={getChipStyle(status)}  onClick={handleClick}>
    <span
      className="status-pill"
      style={{ ...getChipStyle(status), cursor: "pointer" }}
      onClick={handleClick}
    >
      {/* <CircleIcon style={{fontSize: '0.5rem'}} />&nbsp; */}

      {status}
    </span>
  );
}
export default StatusPill;
